'use strict'

import ApiClient from './ApiClient'

export default class ExchangeRepository {
  // TODO 共通化
  setMgmtParam (isMgmt, params) {
    params = params || {}

    if (isMgmt) {
      params.is_mgmt = '1' // TODO this.app_flag.ON
    }

    return params
  }

  /**
   * 交換情報取得
   * @param sid_person
   * @param sid_user
   * @param isMgmt 管理モードフラグ
   * @returns {*}
   */
  getListByUser (sid_person, sid_user, isMgmt) {
    // 名刺管理の場合は、管理モードフラグを付ける
    const params = this.setMgmtParam(isMgmt, { sid_person, sid_user })
    return ApiClient().get(`/exchanges`, { params })
  }

  /**
   * 交換情報取得
   * @param id 交換ID
   * @param isMgmt 管理モードフラグ
   * @returns {*}
   */
  get (id, isMgmt) {
    // 名刺管理の場合は、管理モードフラグを付ける
    const params = this.setMgmtParam(isMgmt)
    return ApiClient().get(`/exchanges/${id}`, { params })
  }

  /**
   * 名刺交換状況を更新します
   * @param {string|int} id 交換ID
   * @param {object} params
   * @param {bool} isMgmt 管理モードフラグ
   * @returns {*}
   */
  put (id, params, isMgmt) {
    // 名刺管理の場合は、管理モードフラグを付ける
    return ApiClient().put(`/exchanges/${id}`, params, {params: this.setMgmtParam(isMgmt)})
  }

  /**
   * 名刺交換状況を削除します
   * @param id 交換ID
   * @param isMgmt 管理モードフラグ
   * @returns {*}
   */
  delete (id, isMgmt) {
    // 名刺管理の場合は、管理モードフラグを付ける
    const params = this.setMgmtParam(isMgmt)
    return ApiClient().delete(`/exchanges/${id}`, { params })
  }

  /**
   * 指定された名刺人物からユーザーの交換情報を全て削除します
   * @param person_id 人物ID
   * @returns {*}
   */
  deleteAll (person_id) {
    return ApiClient().delete(`/exchanges/delete/${person_id}`)
  }
}



// WEBPACK FOOTER //
// ./src/repositories/ExchangeRepository.js